import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();
const t = block_translation;

export class SoundSrcAttribute extends AbstractBlock {
  constructor() {
    super('sound_att_v2', t.to('サウンド', 'sound'));
    this.setNameForCode('sound');
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setAttributeShape(block);
    ColorSettings.setAttributeColor(block);
    ShapeSettings.setTitleField(block, this.title);

    const path = new Blockly.FieldTextInput('');
    block.appendDummyInput().appendField(path, 'src');

    const volume = new Blockly.FieldTextInput('1.0');
    block.appendDummyInput().appendField(volume, 'volume');

    const loop = new Blockly.FieldDropdown([
      [t.to('はい', 'yes'), 'true'],
      [t.to('いいえ', 'no'), 'false'],
    ]);
    block.appendDummyInput().appendField(t.to('繰り返し', 'loop')).appendField(loop, 'loop');

    const autoplay = new Blockly.FieldDropdown([
      [t.to('自動再生', 'auto_play'), 'auto'],
      [t.to('クリック', 'click'), 'click'],
    ]);
    block.appendDummyInput().appendField(autoplay, 'autoplay');

    ShapeSettings.addAttributeInput(block);
  }

  codeGenerateCore(block: BlockType): string[] {
    const path = CodeSetting.getFieldValue(block, 'src');
    const loop = CodeSetting.getFieldValue(block, 'loop');
    const autoplay = CodeSetting.getFieldValue(block, 'autoplay');
    const volume = CodeSetting.getFieldValue(block, 'volume');

    let attribute = CodeSetting.getSubAttributeCode(block);
    attribute += CodeSetting.getAttributeCode('sound_start', `by:${autoplay}`);
    const str = CodeSetting.buildAttribute(
      [
        ['sound', `src:url(${path});autoplay:false;loop:${loop};poolSize:2;volume:${volume};`],
        ['class', 'clickable collidable'],
      ],
      attribute
    );
    // [['sound', `src:url(${path});autoplay:false;loop:${loop};${autoplay === 'true' ? '' : 'on:click;'}poolSize:2;volume:${volume};`]],

    return [str];
  }
}
